import { RRule, type Options } from "rrule";

const SHORTEST_MONTH = 28;

function utcDate(iso: string): Date {
  const [year, month, day] = iso.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day));
}

// ice_cube clamps a month or year without its own day list to the anchor's day or the
// month's last day, where RFC 5545 (and rrule.js) would skip the short month.
function clampedToMonthEnd(options: Partial<Options>, anchor: Date): Partial<Options> {
  const ownDays = options.bymonthday ?? options.byweekday ?? options.byyearday ?? options.byweekno ?? options.bysetpos;
  const day = anchor.getUTCDate();
  if (ownDays || day <= SHORTEST_MONTH) return options;
  if (options.freq === RRule.MONTHLY) return { ...options, bymonthday: [day, -1], bysetpos: [1] };
  if (options.freq === RRule.YEARLY) {
    return { ...options, bymonth: options.bymonth ?? [anchor.getUTCMonth() + 1], bymonthday: [day, -1], bysetpos: [1] };
  }
  return options;
}

// Mirrors Task#next_recurrence_date: the first occurrence after the anchor date, null
// for a rule the server can't read either. Weeks start on Sunday, as in ice_cube.
export function nextOccurrence(rule: string, anchor: string): string | null {
  try {
    const parsed = RRule.parseString(rule);
    if (parsed.freq === undefined) return null;
    const dtstart = utcDate(anchor);
    const options = clampedToMonthEnd({ ...parsed, dtstart, wkst: RRule.SU }, dtstart);
    return new RRule(options).after(dtstart, false)?.toISOString().slice(0, 10) ?? null;
  } catch {
    return null;
  }
}
